import React from "react";

import './LoanViews.css'

function LoanViews(){
    return(
        <div>

        </div>
    );
}

export default LoanViews;